/*
  Add-on details popup — loaded by snippets/venty-addon-popup.liquid.
  Clicking the photo, name or info button of a main-product "Product bundle" item (e.g. the 30W charger) opens a
  centred popup instead of navigating to the add-on's product page: image, name, price, the description the theme
  already renders in its hidden bundle modal, and an "Add to my order" button that ticks the add-on's checkbox.
  × / backdrop / Esc close it. Only runs on pages that render the snippet.
*/
(() => {
  if (window.ventyAddonPopup) return;
  window.ventyAddonPopup = true;

  const TRIGGERS =
    '[id$="__main-product"] .product-bundle__media, [id$="__main-product"] .product-bundle__title-label, [id$="__main-product"] .product-bundle__info-button';
  let dialog;

  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'venty-v2-addon-dialog';
    dialog.setAttribute('aria-labelledby', 'VentyAddonPopupTitle');
    dialog.innerHTML =
      '<div class="venty-v2-addon-dialog__panel">' +
      '<button type="button" class="venty-v2-addon-dialog__close" data-addon-close aria-label="Close">&times;</button>' +
      '<div class="venty-v2-addon-dialog__media" data-addon-media></div>' +
      '<div class="venty-v2-addon-dialog__body">' +
      '<p class="venty-v2-addon-dialog__title" id="VentyAddonPopupTitle" data-addon-title></p>' +
      '<p class="venty-v2-addon-dialog__price"><span data-addon-price></span><s data-addon-compare></s></p>' +
      '<div class="venty-v2-addon-dialog__text" data-addon-text></div>' +
      '<button type="button" class="venty-v2-addon-dialog__cta" data-addon-cta></button>' +
      '</div></div>';
    document.body.appendChild(dialog);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-addon-close]')) dialog.close();
      if (event.target.closest('[data-addon-cta]') && dialog.checkbox && !dialog.checkbox.disabled) {
        if (!dialog.checkbox.checked) dialog.checkbox.click();
        dialog.close();
      }
    });
  };

  const open = (item) => {
    if (!dialog) build();
    const q = (selector) => item.querySelector(selector);
    const config = document.querySelector('[data-venty-addon-popup]');
    const entry = item.closest('.product-bundle__entry');
    const modalText = entry && entry.querySelector('product-bundle-modal .rte');
    const link = q('.product-bundle__media, .product-bundle__title-label');
    const checkbox = q('.product-bundle__checkbox');
    dialog.checkbox = checkbox;

    // Image: the snippet's chosen product image when this item is that product, else the item's own photo.
    const isConfigured = config && config.dataset.image && link && link.getAttribute('href').includes(`/products/${config.dataset.handle}`);
    const thumb = q('.product-bundle__media img');
    const media = dialog.querySelector('[data-addon-media]');
    media.innerHTML = '';
    media.classList.toggle('is-feature', !!isConfigured);
    const src = isConfigured ? config.dataset.image : thumb && (thumb.currentSrc || thumb.src).replace(/([?&])width=\d+/, '$1width=800');
    if (src) {
      const img = document.createElement('img');
      img.src = src;
      img.alt = (thumb && thumb.alt) || '';
      media.appendChild(img);
    }

    const title = (config && config.dataset.title) || ((q('.product-bundle__title-label') || {}).textContent || '').trim();
    dialog.querySelector('[data-addon-title]').textContent = title;
    dialog.querySelector('[data-addon-price]').textContent = ((q('.product-bundle__price') || {}).textContent || '').trim();
    const compare = q('.product-bundle__compare');
    dialog.querySelector('[data-addon-compare]').textContent = compare && !compare.hidden ? compare.textContent.trim() : '';
    dialog.querySelector('[data-addon-text]').innerHTML = modalText ? modalText.innerHTML : '';

    const cta = dialog.querySelector('[data-addon-cta]');
    const added = checkbox && checkbox.checked;
    cta.textContent = added ? 'Added to your order ✓' : 'Add to my order';
    cta.disabled = !checkbox || checkbox.disabled || added;

    dialog.showModal();
    dialog.querySelector('[data-addon-close]').focus();
  };

  // Capture phase on document: runs before the link navigates or the theme opens its own bundle drawer.
  document.addEventListener(
    'click',
    (event) => {
      if (!document.querySelector('[data-venty-addon-popup]')) return;
      const trigger = event.target.closest(TRIGGERS);
      const item = trigger && trigger.closest('.product-bundle__item');
      if (!item) return;
      event.preventDefault();
      event.stopPropagation();
      open(item);
    },
    true
  );
})();
